import { Query } from '@/app/tracking/api';

export interface QueryQuestionAttemptsTrackingQueryPayload {
}

export type QueryQuestionAttemptsTrackingQueryResult = QuestionAttempts[]

export interface QuestionAttempts {
  id: string
  attempts: QuestionAttempt[]
}

interface QuestionAttempt {
  thinkingTimeSeconds: number
  achievedScore: number
}

export const QueryQuestionAttemptsTrackingQueryName = 'query-question-attempts' as const
export type QueryQuestionAttemptsTrackingQuery =
      Query<typeof QueryQuestionAttemptsTrackingQueryName, QueryQuestionAttemptsTrackingQueryPayload, QueryQuestionAttemptsTrackingQueryResult>


